import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import * as actionsUser from '../user/redux/actions';
import AdminLayout from './AdminLayout';
import { Row, Col, Table, Button, Input, InputNumber, Popconfirm } from 'antd';
import moment from 'moment';
import { API } from '../../helper/api';

const columns = [{
  title: 'Événement',
  dataIndex: 'title',
  key: 'evenement',
}, {
  title: 'Date',
  dataIndex: 'openAt',
  key: 'date',
  render: (text, record) => moment(record.openAt).isSame(record.closeAt, 'day') ? moment(record.openAt).format('LL') : moment(record.openAt).format('LL') + ' - ' + moment(record.closeAt).format('LL') 
}, {
  title: 'Points jury',
  dataIndex: 'juryPoint',
  key: 'pointjuty',
}];

export class Usersprofils extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    juryPoints: [],
    newJuryPointValue: 0,
    newJuryPointDescription: '',
    editJuryPointValue: 0,
    editJuryPointDescription: '',
    modifyingJuryPoints: false,
    editingId: -1
  };

  componentDidMount() {
    this.refresh();
  }

  refresh(){
    this.props.actions.getUser({}, '/user/'+this.props.match.params.id+'/detail')

    this.refreshJuryPoints();
  }

  refreshJuryPoints() {
    API.get('JuryPoint/user/' + this.props.match.params.id)
      .then(res => {
        this.setState({juryPoints: res.data.filter(item => item.eventId === null)});
      });
  }

  createJuryPoint() {
    this.setState({modifyingJuryPoints: true});
    API.post('JuryPoint/create/', { 
      userId: this.props.match.params.id, 
      points: this.state.newJuryPointValue, 
      description: this.state.newJuryPointDescription
    }).then(() => {
      this.refresh();
      this.setState({newJuryPointDescription: '', newJuryPointValue: 0, modifyingJuryPoints: false});
    });
  }

  deleteJuryPoint(jpId) {
    this.setState({modifyingJuryPoints: true});
    API.delete('JuryPoint/' + jpId).then(() => {
      this.refresh();
      this.setState({modifyingJuryPoints: false});
    });
  }

  editJuryPoint() {
    this.setState({modifyingJuryPoints: true});
    API.patch('JuryPoint/', { 
      id: this.state.editingId,
      points: this.state.editJuryPointValue,
      description: this.state.editJuryPointDescription
    }).then(() => {
      this.refresh();
      this.setState({modifyingJuryPoints: false, editingId: -1});
    });
  }

  render() {

    const user = this.props.data.hasOwnProperty("user") ? this.props.data.user : this.props.data;
    const events = this.props.data.hasOwnProperty("events") ? this.props.data.events : [];

    const jpColumns = [{
      title: 'Description',
      render: (i, record) => {
        return this.state.editingId === record.id ? (
          <Input
            placeholder="Description"
            value={this.state.editJuryPointDescription}
            style={{width: '400px'}}
            onChange={(e) => this.setState({ editJuryPointDescription: e.target.value })}
          />) : record.description
      },
      width:'40%'
    }, {
      title: 'Points jury',
      render: (i, record) => {
        return this.state.editingId === record.id ? (
          <InputNumber
            placeholder="Points jury"
            step={0.01}
            defaultValue={0}
            value={this.state.editJuryPointValue}
            min={0}
            max={5}
            style={{width: '150px'}}
            formatter={value => `${value} points jury`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
            parser={value => value.replace(/\s\points jury?|(,*)/g, '')}
            onChange={ (juryPoint) => this.setState({ editJuryPointValue: juryPoint })}
          />) : record.points
      },
      width:'20%'
    }, {
      title: '',
      render: (i, record) => {
        return this.state.editingId === record.id ? (
          <span>
            <Button type="primary" style={{marginRight: '20px'}} onClick={() => this.editJuryPoint()}>Sauvegarder</Button>
            <Button type="ghost" onClick={() => this.setState({editingId: -1})}>Annuler</Button>
          </span>
        ) : (<Button type="primary" onClick={() => this.setState({
          editingId: record.id, 
          editJuryPointDescription: record.description,
          editJuryPointValue: record.points
        })}>Modifier</Button>)
      }
    }, {
      title: '',
      render: (i, record) => {
        return (
          <Popconfirm
            title="Êtes-vous sûr de vouloir supprimer ce(s) point(s) de jury ?"
            onConfirm={() => this.deleteJuryPoint(record.id) }
            okText="Oui"
            cancelText="Non">
            <Button type="danger">Supprimer</Button>
          </Popconfirm>)
      }
    }];

    return (
      <div className="admin-usersprofils">
        <AdminLayout
          title="INFORMATIONS UTILISATEUR"
          loading={this.props.status.getUser.pending || !this.props.data.hasOwnProperty("user") || this.state.modifyingJuryPoints}
          back="/admin/users"
        >
          <Row className="title-admin-user">
            <Col span={24}>
              <h1>{ user.fullName } - <span> { user.role.name }</span></h1>
            </Col>
            <Col span={24}>
              <h2>{ user.promotion.name } - { user.promotion.description }</h2>
            </Col>
          </Row>

          <Row type="flex" justify="center">
            <Col className="bloc-admin" style={{ padding: '2%' }} xs={{ span: 24 }} md={{ span: 12 }}>
              <Col className="bloc-admin-informations" style={{ fontSize: '35px' }} span={24}>
                <p>{ user.totalJuryPoints }</p>
              </Col>
              <Col className="bloc-admin-informations" span={24}>
                <p>points jury</p>
              </Col>
            </Col>
            <Col className="bloc-admin" style={{ padding: '2%' }} xs={{ span: 24 }} md={{ span: 11 }}>
              <Col className="bloc-admin-informations" style={{ fontSize: '35px' }} span={24}>
                <p>{ events.length }</p>
              </Col>
              <Col className="bloc-admin-informations" span={24}>
                <p>participations</p>
              </Col>
            </Col>
          </Row>
          <Row>
            <Col style={{ margin: '25px 0', fontSize: '17px', padding: '0 10px' }} span={24}>
              <h3>Listes des événements</h3>
            </Col>
            <Col span={24}>
              <Table
                dataSource={events}
                columns={columns}
                rowKey={(record) => record.id}
              />
            </Col>
          </Row>
          <Row>
            <Col style={{ margin: '25px 0', fontSize: '17px', padding: '0 10px' }} span={24}>
              <h3>Autres points jury</h3>
            </Col>
            <Col span={24}>
              <Table
                dataSource={this.state.juryPoints}
                columns={jpColumns}
                rowKey={(record) => record.id}
              />
              <div style={{padding: '30px'}}>
                Ajouter des points jury : 
                <InputNumber
                  placeholder="Points jury"
                  step={0.01}
                  defaultValue={0}
                  value={this.state.newJuryPointValue}
                  min={0}
                  max={5}
                  style={{width: '150px', marginLeft: '20px'}}
                  formatter={value => `${value} points jury`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  parser={value => value.replace(/\s\points jury?|(,*)/g, '')}
                  onChange={ (juryPoint) => this.setState({ newJuryPointValue: juryPoint })}
                />
                <Input
                  placeholder="Description"
                  value={this.state.newJuryPointDescription}
                  style={{width: '400px', marginRight: '20px', marginLeft: '20px'}}
                  onChange={(e) => this.setState({ newJuryPointDescription: e.target.value })}
                />
                <Button
                  type="primary"
                  onClick={this.createJuryPoint.bind(this)}
                  disabled={this.state.newJuryPointValue === 0}
                >Ok</Button>
              </div>
            </Col>
          </Row>
        </AdminLayout>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    data: state.user.user,
    status: state.user.status
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions,  ...actionsUser }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Usersprofils);



// WEBPACK FOOTER //
// ./src/features/admin/UsersProfils.js